import "./App.css";
import NavbarComponent from "./Components/NavbarComponent";
import LandingPage from "./Components/LandingPage";
import AboutMe from "./Components/AboutMe";
import Education from "./Components/Education";
import Skills from "./Components/Skills";
import Projects from "./Components/Projects/Projects";
import PhotographyPortfolio from "./Components/PhotographyPortfolio";
import Footer from "./Components/Footer";
import TechnicalExperience2 from "./Components/WorkExperience2";
import WebPortfolio from "./Components/WebPortfolio";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import ScrollToTop from "./Components/ScrollToTop";
import { AnimatePresence, motion } from "framer-motion";

function App() {
  const location = useLocation();

  return (
    <div className="App" id="dark">
      <div className="line-container">
        <svg className="line-layer line-layer-desktop" viewBox="0 0 800 500" preserveAspectRatio="none">
          <path className="line-draw-1" d="M -50 380 C 150 300, 250 450, 450 320 S 700 200, 850 260" />
          <path className="line-draw-2" d="M -50 120 C 200 60, 300 220, 500 140 S 750 40, 850 100" />
          <path className="line-draw-3" d="M -50 250 C 180 320, 320 150, 480 260 S 680 380, 850 300" />
        </svg>
        <svg className="line-layer line-layer-mobile" viewBox="0 0 400 800" preserveAspectRatio="none">
          <path className="line-draw-1" d="M -50 200 C 100 350, 300 150, 250 400 S 100 600, 350 650" />
          <path className="line-draw-2" d="M -50 500 C 150 350, 250 600, 200 250 S 350 100, 450 150" />
        </svg>
      </div>
      <NavbarComponent />
      <ScrollToTop />
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -15 }}
          transition={{ duration: 0.35, ease: "easeInOut" }}
          className="page-content"
        >
          <Routes location={location} key={location.pathname}>
            <Route
              path="/"
              element={
                <>
                  <LandingPage />
                  <AboutMe />
                  <Education />
                  <Skills />
                  <Footer />
                </>
              }
            />
            <Route
              path="/technicalExperience"
              element={
                <>
                  <TechnicalExperience2 />
                  <Footer />
                </>
              }
            />
            <Route
              path="/projects"
              element={
                <>
                  <Projects />
                  <WebPortfolio />
                  <Footer />
                </>
              }
            />
            <Route
              path="/photographyPortfolio"
              element={
                <>
                  <PhotographyPortfolio />
                  <Footer />
                </>
              }
            />
            {/* Fallback & Legacy Route Redirects */}
            <Route path="/aboutMe" element={<Navigate to="/" replace />} />
            <Route path="/education" element={<Navigate to="/" replace />} />
            <Route path="/skills" element={<Navigate to="/" replace />} />
            <Route path="/web-portfolio" element={<Navigate to="/projects" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

export default App;